// Generated by CoffeeScript 2.7.0
var Optionable;

import {
  FieldOption,
  FieldOptionProxy
} from '../../field_option.js';

export default Optionable = {
  insertOption: function(index = this.options.length, option) {
    if (!option) {
      option = this.generateOption();
    }
    this.options.splice(index, 0, option);
    return option;
  },
  addOptions: function(values = []) {
    return this.options.splice.apply(this.options, [this.options.length, 0].concat(values.map((value) => {
      return this.generateOption(value.trim());
    })));
  },
  generateOption: function(value = '新选项') {
    return new FieldOption({
      value: value
    }, this);
  },
  removeOption: function(option) {
    var index;
    if (option.isNew()) {
      index = _.indexOf(this.options, option);
      return this.options.splice(index, 1);
    } else {
      return option._destroy = true;
    }
  },
  moveOptionTo: function(current, target) {
    var option;
    option = this.options.splice(current, 1)[0];
    return this.options.splice(target, 0, option);
  },
  updateOtherOption: function() {
    return this._makeOtherOption(this.other_option, this.settings);
  },
  toggleOtherOption: function() {
    if (this.other_option) {
      this.other_option = '';
    } else {
      this.other_option = '其他';
    }
    return this._makeOtherOption(this.other_option, {});
  },
  _makeOptions: function(options, other_option = '', settings = {}) {
    this.options = _.chain(options).sortBy('position').map((option) => {
      return new FieldOption(option, this);
    }).value();
    return this._makeOtherOption(other_option, settings);
  },
  _makeOtherOption: function(other_option = '', settings = {}) {
    this.hasOtherOption = !_.isEmpty(other_option);
    if (this.hasOtherOption) {
      return this.otherOption = new FieldOption({
        id: 0,
        value: '',
        label: other_option,
        valid_hit_count: this.other_option_valid_hit_count,
        settings: {
          limit_settings: settings.dig('other_option_settings', 'limit')
        }
      }, this);
    } else {
      return this.otherOption = null;
    }
  }
};
